import React, { useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import withErrorGuard from "../../HOC/withErrorGuard";
import WebglErrorView from "../../HOC/withErrorGuard/WebglErrorView";
import { getVariantId } from "../../state/selectors/general.selectors";
import Pulsar from "../Pulsar";
import getRegionBrowserTracks from "./getRegionBrowserTracks";
import {
  getPosition,
  getAcmgTranscript,
} from "../../state/selectors/Pulsar.selectors";
import {
  CONSERVATION_CL,
  FREQ_CL,
  GERMLINE_CL,
  OTHER_CL,
  PATHOGENICITY_CL,
  SOMATIC_CL,
  TRANSCRIPT_CL,
  IMPACT_NULL_VARS_CL,
  IMPACT_OTHER_CL,
} from "../Pulsar/constants/options";

function RegionBrowser(props) {
  const { acmgTranscript, variantId, position } = props;
  const { start, end, visStart, visEnd } = position;
  const tracks = useMemo(() => getRegionBrowserTracks(), []);

  return (
    <Pulsar
      title="Region Browser"
      key="region-browser"
      trackConfs={tracks}
      visStart={visStart}
      visEnd={visEnd}
      start={start}
      allowedColorScales={[
        CONSERVATION_CL,
        TRANSCRIPT_CL,
        PATHOGENICITY_CL,
        FREQ_CL,
        GERMLINE_CL,
        SOMATIC_CL,
        OTHER_CL,
      ]}
      allowedColorScaleCategories={[
        {
          name: "Coding Impact",
          scales: [IMPACT_NULL_VARS_CL, IMPACT_OTHER_CL],
        },
      ]}
      end={end}
      state={{
        selectedVariantId: variantId,
        selectedTranscript: acmgTranscript,
      }}
    />
  );
}

RegionBrowser.propTypes = {
  position: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
    visStart: PropTypes.number,
    visEnd: PropTypes.number,
  }).isRequired,
  variantId: PropTypes.string,
  acmgTranscript: PropTypes.string,
};

RegionBrowser.defaultProps = {
  variantId: null,
  acmgTranscript: null,
};

const mapStateToProps = (state) => {
  return {
    position: getPosition(state),
    variantId: getVariantId(state),
    acmgTranscript: getAcmgTranscript(state),
  };
};

export default connect(mapStateToProps)(
  withErrorGuard(
    RegionBrowser,
    "RegionBrowser",
    "Region Browser",
    WebglErrorView
  )
);
